<template>
  <div>
    <Carousel />
    <Intro />
    <!-- <PopularProducts /> -->
    <Overview />
  </div>
</template>

<script>
import Carousel from "../components/start/Carousel";
import Intro from "../components/start/Intro";
import Overview from "../components/start/Overview";
// import PopularProducts from "../components/shop/PopularProducts";

export default {
  data() {
    return {};
  },
  components: {
    Carousel,
    Intro,
    Overview
    // PopularProducts
  },
  methods: {
    navAnbau(target) {
      this.$router.push(target);
    }
  },
  mounted() {
    this.$vuetify.goTo(0);
  }
};
</script>
